import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

// Relative fetches ("Building/GetElevators") resolve against the current path.
// /buildingportal works; /buildingportal/{id} (report deep links) hits
// /buildingportal/Building/... and the listings stay empty.
const nativeFetch = window.fetch.bind(window);
window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
	if (typeof input === "string" && input.length > 0 && !input.startsWith("/") && !/^[a-z][a-z0-9+.-]*:/i.test(input)) {
		input = "/" + input;
	}
	return nativeFetch(input, init);
};

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
	<React.StrictMode>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
